import { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
}

/**
 * Simple page container for pages without ads
 */
export default function PageContainer({ children }: PageContainerProps) {
  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "16px" }}>
      {children}
    </div>
  );
}
